import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import fromConfiguration from '../../configuration/fromConfiguration';

function a11yProps(idPrefix) {
  return {
    id: `${idPrefix}-tab`,
    'aria-controls': `${idPrefix}-tabpanel`,
  };
}

function TabPanel(props) {
  const { value, index, id, label, type, configuration, fullHeight, ...rest } = props;
  const [{ Component }] = useState({
    Component: fromConfiguration({ type, configuration, viewService: props.viewService }),
  });
  const style = {
    flex: '0 0 100%',
  };
  if (fullHeight) {
    style.display = value === index ? 'flex' : 'none';
  }
  return (
    <div
      className={classnames('grb-swipeable-tab-panel')}
      role="tabpanel"
      id={`${id}-tabpanel`}
      aria-labelledby={`${id}-tab`}
      style={style}
    >
      <Component tabId={id} {...rest} />
    </div>
  );
}

TabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]).isRequired,
  configuration: PropTypes.shape({}),
  viewService: PropTypes.shape({
    getComponent: PropTypes.func,
  }).isRequired,
  fullHeight: PropTypes.bool,
};

TabPanel.defaultProps = {
  configuration: undefined,
  fullHeight: false,
};

export { TabPanel as default, a11yProps };
